// MIT License - Copyright (c) 2026 Doug McNall

import { starSystems, starPositions } from './StarSystemsConfig';
import { warpGates, warpGatePositions } from './WarpGatesConfig';
import { DCAliensPlanets } from './AliensConfig';

export const universeDC = {
  id: 'dc',
  starSystems,
  starPositions,
  warpGates,
  warpGatePositions,
  aliens: DCAliensPlanets
};

export default universeDC;
